import React from 'react'
// ##
import CompanyProductsTable from '../../modules/CompanyProduct/components/CompanyProductsTable'

export default function BrandPage() {
  return <CompanyProductsTable />
}
